import React, { useState } from "react";
import PropTypes from "prop-types";
import { ListItem, Box } from "@mui/material";
import { getBackground, getBorderColor, getVariantText } from "../../../../../../utils/helper";
import AreaInput from "../../../input-types/AreaInput";
import QuelleInput from "../../../input-types/QuelleInput";
import ReportCommentInput from "../../../input-types/ReportCommentInput";
import TextEditorInput from "../../../input-types/TextEditorInput";
import TextInput from "../../../input-types/TextInput";
import AddressInput from "../../../input-types/AddressInput";
import DateInput, { YearDateInput } from "../../../input-types/DateInput";
import { useDispatch, useSelector } from "react-redux";
import { setUpdatedRows } from "./buildingProfileTableSlice";
import NumberInput from "../../../input-types/NumberInput";

const RenderNodeValues = ({ item, onUpdate }) => {
  const [inputValues, setInputValues] = useState(item.nodeValue);
  const dispatch = useDispatch();
  const state = useSelector((state) => state.buildingProfileTable);


  const onUpdateCheck = (item, nodeValues) => {
    nodeValues.forEach((node, i) => {
      if(node.updated){
        let tempObj = {
          nodeIdent: item.nodeIdent,
          subAssetIdent: node.subAsset.subAssetIdent,
          labelTranslation: item.labelTranslation,
          updated: node.updated,
          item: item,
        };
        dispatch(setUpdatedRows(tempObj));
        //dispatch(selectedOptionStructure(tempObj));
      }
    })
  };

  const onChange = (value, node, isUpdated, subAsset, item) => {
    if (isUpdated) {
        let temp = inputValues.map((m) => {
          if (m.subAsset.subAssetIdent === subAsset.subAssetIdent) {
            return {
                ...m,
                value: value,
                updated: isUpdated, 
            };
          } else {
            return m;
          }
        });
        setInputValues(temp);
        onUpdate(item, temp);
        onUpdateCheck(item,temp);
      }
  };

  const onQuelleChange = (value, node, isUpdated, subAsset, item) => {
    if (isUpdated) {
        let temp = item.nodeValue.map((m) => {
          if (m.subAsset.subAssetIdent === subAsset.subAssetIdent) {
            return {
                ...m,
                quelle: value,
                updated: isUpdated,
            };
          } else {
            return m;
          }
        });
        onUpdate(item, temp);
  };
}

  const onCommentChange = (value, node, isUpdated, subAsset, item) => {
    if (isUpdated) {
        let temp = item.nodeValue.map((m) => {
          if (m.subAsset.subAssetIdent === subAsset.subAssetIdent) {
            return {
                ...m,
                comment: value,
                updated: isUpdated,
            };
          } else {
            return m;
          }
        });
        onUpdate(item, temp);
  };
}
  const renderNodeValues = (item, node, index) => {
    let subAsset = node.subAsset;
    let found = state.updatedRows?.some(
      (f) =>
        f.nodeIdent === item.nodeIdent &&
        f.subAssetIdent === subAsset.subAssetIdent
    );
    return (
      <ListItem
        className={"d-flex flex-column justify-contents-start w-100 p-0"}
        id={`id-${item.nodeIdent}-${subAsset.subAssetIdent}`}
        key={`key-${item.nodeIdent}-${subAsset.subAssetIdent}`}
        style={{borderLeft: getBorderColor(found),
        backgroundColor: getBackground(found)
        }}
      >
        <Box className={"d-flex align-items-center flex-wrap w-100"}>
            <div style={{ width: "25%" }} className="d-flex">
              <div className="d-flex  justify-content-start m-1">
                {getVariantText(subAsset.name, "caption", {
                  color: "#254a9a",
                  textTransform: "uppercase",
                  wordBreak: "break-all",
                })}
              </div>
            </div>

          <div
            className="p-1"
            style={{ width: "75%"}}
          >
            <div className="p-1 w-100">
              {getInputFields(item, node, subAsset)}
            </div>
          </div>
        </Box>
      </ListItem>
    );
  };

  const getInputFields = (item, node, subAsset) => {
    const id = `id-${item.nodeName}-${subAsset.subAssetIdent}`;
    const key = `key-${item.nodeName}-${subAsset.subAssetIdent}`;
    const disabled = item.disabled || false;

    if (item.nodeType.includes("-number")) {
      return (
        <Box className="d-flex w-100 p-1">
          <Box style={{ width: "33%" }} className="m-1">
            <NumberInput
              id={id}
              key={key}
              disabled={disabled}
              node={node}
              handleChange={(value, node , isUpdated) =>
                onChange(value, node, isUpdated, subAsset, item)
              }
            />
          </Box>
          <Box style={{ width: "33%" }} className="m-1">
            <QuelleInput
              id={id}
              key={key}
              disabled={disabled}
              node={node}
              handleQuelleChange={(value, node, isUpdated) =>
                onQuelleChange(value, node,isUpdated, subAsset, item)
              }
            />
          </Box>
          <Box style={{ width: "33%" }} className="m-1">
            <ReportCommentInput
              id={`${id}-comment`}
              key={`${key}-comment`}
              disabled={disabled}
              node={node}
              handleCommentChange={(value, node , isUpdated) =>
                onCommentChange(value, node, isUpdated, subAsset, item)
              }
            />
          </Box>
        </Box>
      );
    }
    if (item.nodeType.includes("-area")) {
      return (
        <Box className="d-flex w-100 p-1">
          <Box style={{ width: "33%" }} className="m-1">
            <AreaInput
              id={id}
              key={key}
              disabled={disabled}
              node={node}
              handleChange={(value, node , isUpdated) =>
                onChange(value, node, isUpdated, subAsset, item)
              }
            />
          </Box>
          <Box style={{ width: "33%" }} className="m-1">
            <QuelleInput
              id={id}
              key={key}
              disabled={disabled}
              node={node}
              handleQuelleChange={(value, node, isUpdated) =>
                onQuelleChange(value, node,isUpdated, subAsset, item)
              }
            />
          </Box>
          <Box style={{ width: "33%" }} className="m-1">
            <ReportCommentInput
              id={`${id}-comment`}
              key={`${key}-comment`}
              disabled={disabled}
              node={node}
              handleCommentChange={(value, node , isUpdated) =>
                onCommentChange(value, node, isUpdated, subAsset, item)
              }
            />
          </Box>
        </Box>
      );
    }

    switch (item.nodeType) {
      case "textarea":
        return (
          <Box className="d-flex flex-column w-100 p-1">
            <Box style={{ width: "100%" }} className="m-1">
              <TextEditorInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleChange={(value, node , isUpdated) =>
                    onChange(value, node, isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box className="d-flex w-100">
              <Box style={{ width: "50%" }} className="m-1">
                <QuelleInput
                  id={id}
                  key={key}
                  disabled={disabled}
                  node={node}
                  handleQuelleChange={(value, node, isUpdated) =>
                      onQuelleChange(value, node,isUpdated, subAsset, item)
                    }
                />
              </Box>
              <Box style={{ width: "50%" }} className="m-1">
                <ReportCommentInput
                  id={`${id}-comment`}
                  key={`${key}-comment`}
                  disabled={disabled}
                  node={node}
                  handleCommentChange={(value, node , isUpdated) =>
                    onCommentChange(value, node, isUpdated, subAsset, item)
                  }
                />
              </Box>
            </Box>
          </Box>
        );

      case "number":
        return (
          <Box className="d-flex w-100 p-1">
            <Box style={{ width: "33%" }} className="m-1">
              <NumberInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleChange={(value, node , isUpdated) =>
                    onChange(value, node, isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <QuelleInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleQuelleChange={(value, node, isUpdated) =>
                    onQuelleChange(value, node,isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <ReportCommentInput
                id={`${id}-comment`}
                key={`${key}-comment`}
                disabled={disabled}
                node={node}
                handleCommentChange={(value, node , isUpdated) =>
                  onCommentChange(value, node, isUpdated, subAsset, item)
                }
              />
            </Box>
          </Box>
        );

      case "area":
        return (
          <Box className="d-flex w-100 p-1">
            <Box style={{ width: "33%" }} className="m-1">
              <AreaInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleChange={(value, node , isUpdated) =>
                    onChange(value, node, isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <QuelleInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleQuelleChange={(value, node, isUpdated) =>
                    onQuelleChange(value, node,isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <ReportCommentInput
                id={`${id}-comment`}
                key={`${key}-comment`}
                disabled={disabled}
                node={node}
                handleCommentChange={(value, node , isUpdated) =>
                  onCommentChange(value, node, isUpdated, subAsset, item)
                }
              />
            </Box>
          </Box>
        );

      case "date":
      case "date-future":
        return (
          <Box className="d-flex w-100 p-1">
            <Box style={{ width: "33%" }} className="m-1">
              <DateInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                disableFuture={item.type === "date"}
                handleChange={(value, node , isUpdated) =>
                    onChange(value, node, isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <QuelleInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleQuelleChange={(value, node, isUpdated) =>
                    onQuelleChange(value, node,isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <ReportCommentInput
                id={`${id}-comment`}
                key={`${key}-comment`}
                disabled={disabled}
                node={node}
                handleCommentChange={(value, node , isUpdated) =>
                  onCommentChange(value, node, isUpdated, subAsset, item)
                }
              />
            </Box>
          </Box>
        );

      case "date-year":
        return (
          <Box className="d-flex w-100 p-1">
            <Box style={{ width: "33%" }} className="m-1">
            <TextInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleChange={(value, node , isUpdated) =>
                    onChange(value, node, isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <QuelleInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleQuelleChange={(value, node, isUpdated) =>
                    onQuelleChange(value, node,isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <ReportCommentInput
                id={`${id}-comment`}
                key={`${key}-comment`}
                disabled={disabled}
                node={node}
                handleCommentChange={(value, node , isUpdated) =>
                  onCommentChange(value, node, isUpdated, subAsset, item)
                }
              />
            </Box>
          </Box>
        );

      case "address":
        return (
          <Box className="d-flex  flex-column w-100">
            <Box style={{ width: "100%" }} className="m-1">
              <AddressInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                mapConfig={{
                  nodeIdent: item.nodeIdent,
                  ident: subAsset.subAssetIdent,
                  value: node.value,
                }}
                handleChange={(value, node , isUpdated) =>
                    onChange(value, node, isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box className="d-flex w-100">
              <Box style={{ width: "50%" }} className="m-1">
                <QuelleInput
                  id={id}
                  key={key}
                  disabled={disabled}
                  node={node}
                  handleQuelleChange={(value, node, isUpdated) =>
                      onQuelleChange(value, node,isUpdated, subAsset, item)
                    }
                />
              </Box>
              <Box style={{ width: "50%" }} className="m-1">
                <ReportCommentInput
                  id={`${id}-comment`}
                  key={`${key}-comment`}
                  disabled={disabled}
                  node={node}
                  handleCommentChange={(value, node , isUpdated) =>
                    onCommentChange(value, node, isUpdated, subAsset, item)
                  }
                />
              </Box>
            </Box>
          </Box>
        );

      default:
        return (
          <Box className="d-flex w-100 ">
            <Box style={{ width: "33%" }} className="m-1">
              <TextInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleChange={(value, node , isUpdated) =>
                    onChange(value, node, isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <QuelleInput
                id={id}
                key={key}
                disabled={disabled}
                node={node}
                handleQuelleChange={(value, node, isUpdated) =>
                    onQuelleChange(value, node,isUpdated, subAsset, item)
                  }
              />
            </Box>
            <Box style={{ width: "33%" }} className="m-1">
              <ReportCommentInput
                id={`${id}-comment`}
                key={`${key}-comment`}
                disabled={disabled}
                node={node}
                handleCommentChange={(value, node , isUpdated) =>
                  onCommentChange(value, node, isUpdated, subAsset, item)
                }
              />
            </Box>
          </Box>
        );
    }
  };

  // Helper function to check if property matches any keywords
  const propertyMatchesKeywords = (property, keywords) => {
    return keywords.some(keyword =>
      property.nodeName?.toUpperCase().includes(keyword.toUpperCase()) ||
      property.labelTranslation?.some(label =>
        label.title?.toUpperCase().includes(keyword.toUpperCase())
      )
    );
  };

  // Define common fields (show ALL sub-assets for these)
  const commonFields = [
    'LOCATION', 'ADRESSE', 'STANDORT', 'LAGE', 'ORT',
    'CONSTRUCTION YEAR', 'BAUJAHR', 'ERRICHTUNGSJAHR',
    'TYPE OF USE', 'NUTZUNGSART', 'NUTZUNG', 'VERWENDUNG',
    'PLOT AREA', 'GRUNDSTÜCKSFLÄCHE', 'GRUNDFLÄCHE',
    'GROSS FLOOR AREA', 'BRUTTOGRUNDFLÄCHE', 'BGF',
    'RENTAL AREA', 'MIETFLÄCHE',
    'TOTAL FLOORS', 'STOCKWERKE INSG', 'GESAMTSTOCKWERKE',
    'FLOORS ABOVE GROUND', 'STOCKWERKE OBERIRDISCH', 'OBERIRDISCHE STOCKWERKE',
    'FLOORS UNDERGROUND', 'STOCKWERKE UNTERIRDISCH', 'UNTERIRDISCHE STOCKWERKE',
    'TOTAL CAR PARKING SPACES', 'GESAMTE ANZAHL PARKPLÄTZE', 'PARKPLÄTZE GESAMT'
  ];

  // Define special fields by type (only show matching sub-assets)
  const specialFieldsByType = {
    'Wohnen': ['NUMBER OF FLATS', 'ANZAHL DER WOHNUNGEN', 'ANZAHL WOHNUNGEN', 'WOHNUNGSANZAHL'],
    'Logistik': ['FLOOR LOAD CAPACITY', 'TRAGFÄHIGKEIT BODEN', 'BODENBELASTUNG', 'CLEAR HEIGHT', 'LICHTE HÖHE', 'DECKENHÖHE', 'RAUMHÖHE'],
    'Hotel': ['NUMBER OF GUESTROOMS', 'ANZAHL GÄSTEZIMMER', 'ZIMMERANZAHL', 'GÄSTERÄUME'],
    'Büro': ['PARKING SPACES WITH E-CHARGING STATION', 'STELLPLÄTZE MIT E-LADESTATION', 'E-LADESTATION']
  };

  // Map English to German asset type names
  const assetTypeMapping = {
    'Logistic': 'Logistik',
    'Logistics': 'Logistik',
    'Residential': 'Wohnen',
    'Hotel': 'Hotel',
    'Office': 'Büro',
    'Büro': 'Büro'
  };

  // Filter nodeValues to only show relevant sub-assets
  const getFilteredNodeValues = () => {
    // If it's a common field, show all sub-assets
    if (propertyMatchesKeywords(item, commonFields)) {
      return inputValues;
    }

    // For special fields, only show sub-assets that match the field's type
    // Determine which sub-asset types this field applies to
    const applicableTypes = [];
    Object.keys(specialFieldsByType).forEach(assetType => {
      if (propertyMatchesKeywords(item, specialFieldsByType[assetType])) {
        applicableTypes.push(assetType);
      }
    });

    // If no special types matched, show all (default behavior)
    if (applicableTypes.length === 0) {
      return inputValues;
    }

    // Filter nodeValues to only show those matching applicable types
    return inputValues.filter(node => {
      // Try to get the sub-asset type from various possible properties
      const rawType = node.subAsset.subAssetType ||
                      node.subAsset.type ||
                      node.subAsset.value;

      // Map English names to German if needed
      const subAssetType = assetTypeMapping[rawType] || rawType;

      // Also check by name (e.g., "RESIDENTIAL" -> "Wohnen")
      const name = node.subAsset.name?.toUpperCase();
      const matchesByName = name && (
        (name.includes('LOGISTIC') && applicableTypes.includes('Logistik')) ||
        (name.includes('RESIDENTIAL') && applicableTypes.includes('Wohnen')) ||
        (name.includes('WOHNEN') && applicableTypes.includes('Wohnen')) ||
        (name.includes('HOTEL') && applicableTypes.includes('Hotel')) ||
        (name.includes('OFFICE') && applicableTypes.includes('Büro')) ||
        (name.includes('BÜRO') && applicableTypes.includes('Büro'))
      );

      const isIncluded = applicableTypes.includes(subAssetType) || matchesByName;
      return isIncluded;
    });
  };

  const filteredNodeValues = getFilteredNodeValues();

  return (
    <>
      {!!filteredNodeValues &&
        filteredNodeValues.length > 0 &&
        filteredNodeValues.map((node, index) => {
          return renderNodeValues(item, node, index);
        })}
    </>
  );
};

RenderNodeValues.propTypes = {};

export default RenderNodeValues;
